import React from "react";
import { useFormikContext } from "formik";
// import InputComponent from "../Input/TextFieldComponent";
// import SelectOptionComponent from "../SelectOptions/SelectOptionComponent";
import TextFieldComponent from "../Input/TextFieldComponent";
import StyledSelect from "../SelectOption/SelectOptionComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const errorStyleInput = {
	borderColor: "#B71C1C",
};

function FormComponent(props) {
	const { type } = props;

	const {
		setFieldValue,
		setFieldTouched,
		handleBlur,
		handleChange,
		values,
		errors,
		touched,
	} = useFormikContext();
	console.log(values, errors, touched, "values");

	const formCases = () => {
		switch (type) {
			case "password":
			case "text":
				return (
					<TextFieldComponent
						handleBlur={handleBlur}
						handleChange={handleChange}
						values={values}
						errors={errors}
						touched={touched}
						errorStyleInput={errorStyleInput}
						setFieldValue={setFieldValue}
						{...props}
					/>
				);
			
			case "textarea":
				return (
					<textarea className="form-control" id={props.name} rows={props.row}></textarea>
				);
				
			case "date-picker":
				// let todayDate = new Date();
				return (
					<input
						type="date"
						autoComplete="off"
						className={
							false
								? ["form-control form-control--error"].join(" ")
								: props.className || "form-control"
						}
						name={props.name}
						onBlur={handleBlur}
						onChange={(date) => {
							handleChange(date);
							// setFieldValue(props.name, date);
							props.onChangeCallbackAction &&
								props.onChangeCallbackAction(date);
						}}
						placeholderText={props.placeholder && props.placeholder}
						ref={props.ref}
						max={new Date().toISOString().slice(0,10)}
						disabled={props.disabled}
					/>
					// <DatePicker
					// 	autoComplete="off"
					// 	selected={values ? values[props.name] : null}
					// 	dateFormat={
					// 		props.dateFormat
					// 			? props.dateFormat
					// 			: "yyyy-MM-dd"
					// 	}
					// 	className={
					// 		false
					// 			? ["form-control form-control--error"].join(
					// 					" "
					// 			  )
					// 			: props.className || "form-control"
					// 	}
					// 	name={props.name}
					// 	onChange={(date) => {
					// 		setFieldValue(props.name, date);
					// 		if (props.onChangeCallbackAction)
					// 			props.onChangeCallbackAction(date);
					// 	}}
					// 	placeholderText={props.placeholder && props.placeholder}
					// 	showYearDropdown={true}
					// 	showMonthDropdown={true}
					// 	// {...props.dateSettings}
					// 	ref={props.ref}
					// 	disabled={props.disabled}
					// />
				);

			case "react-select":
				return (
					<StyledSelect
						multiCheckbox={false}
						isDisabled={props.disabled}
						onBlur={() => {
							setFieldTouched(props.name, true);
						}}
						options={props.options}
						value={values ? values[props.name] : null}
						touched={touched[`${props.name}`]}
						error={errors[`${props.name}`]}
						name={props.name}
						id={props.name}
						multi={props.multi ? true : false}
						isSearchable={true}
						onChange={(e) => {
							props.onChange
								? props.onChange(e)
								: handleChange({
										target: {
											name: e.name,
											value: e.value,
										},
								  });
							if (props.onChangeCallbackAction)
								props.onChangeCallbackAction({
									target: { name: e.name, value: e.value },
								});
						}}
						placeholder={props.placeholder}
						{...props.selectSettings}
						calculateValueOnChange={false}
						customStyles={
							(errors[`${props.name}`] &&
								touched[`${props.name}`] &&
								errorStyleInput,
							props.className === "form-select-lg" &&
								props.selectLgStyleInput)
						}
						isMulti={props.multi ? true : false}
					/>
				);

			case "radio":
				return (
					<>
						{props.options.map((radio, index) => {
							return (
								<div
									className={`form-check form-check-inline ${
										index !== 0 && "ml-3"
									}`}
									key={radio.value}
								>
									<input
										disabled={props.disabled}
										className="form-check-input"
										id={`${props.name}-${radio.value}`}
										name={props.name}
										type="radio"
										value={radio.value}
										checked={
											values[props.name] === radio.value
										}
										onBlur={handleBlur}
										onChange={(e) => {
											props.onChange
												? props.onChange(e)
												: handleChange({
														target: {
															name: e.target.name,
															value: e.target
																.value,
														},
												  });
											if (props.onChangeCallbackAction)
												props.onChangeCallbackAction(e);
										}}
									/>
									<label
										className={`${
											props.disabled
												? "cursor-disabled form-check-label"
												: "form-check-label"
										}`}
										htmlFor={`${props.name}-${radio.value}`}
									>
										{radio.label}
									</label>
								</div>
							);
						})}
					</>
				);

			default:
				return null;
		}
	};

	return (
		<div>
			{formCases()}
			{errors[props.name] && touched[props.name] && (
				<div
					style={{
						color: "red",
						marginTop: "5px",
						fontSize: "14px",
					}}
					className="error"
				>
					{errors[props.name]}
				</div>
			)}
		</div>
	);
}

export default FormComponent;
